"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = void 0;
const axios_1 = __importDefault(require("axios"));
const types_1 = require("../types");
const streamingSwapRegex = /:(\d+|(\d+(?:e[+-]?\d+)?))\/\d+\/\d+:/;
const getLiquidityType = (pool) => (pool.includes('/') ? 'Savers' : 'LP');
const getSwapType = (memo) => streamingSwapRegex.test(memo) ? 'Streaming' : 'Standard';
class Parser {
    constructor(args) {
        this.getExtraMetadata = async (memo) => {
            const [type, txid] = memo.split(':');
            const { data } = await this.axiosMidgard.get(`/actions?txid=${txid}`);
            const action = data.actions[data.actions.length - 1];
            if (!action)
                return;
            const swapMemo = action.metadata?.swap?.memo ?? '';
            const [swapType] = swapMemo.split(':');
            const refundMemo = action.metadata?.refund?.memo ?? '';
            const [refundType] = refundMemo.split(':');
            const txType = (() => {
                if (swapType) {
                    switch (swapType.toLowerCase()) {
                        case '$+':
                        case 'loan+':
                            return 'loanOpen';
                        case '$-':
                        case 'loan-':
                            return 'loanRepayment';
                        default:
                            return action.type;
                    }
                }
                if (refundType) {
                    switch (refundType.toLowerCase()) {
                        case 'swap':
                        case '=':
                        case 's':
                            return 'swap';
                        case '$+':
                        case 'loan+':
                            return 'loanOpen';
                        case '$-':
                        case 'loan-':
                            return 'loanRepayment';
                        case 'add':
                        case '+':
                            return 'deposit';
                        case 'withdraw':
                        case '-':
                        case 'wd':
                            return 'withdraw';
                        default:
                            return action.type;
                    }
                }
                return action.type;
            })();
            const method = (() => {
                switch (type.toLowerCase()) {
                    case 'out': {
                        return txType ? `${txType}Out` : 'out';
                    }
                    case 'refund': {
                        return txType ? `${txType}Refund` : 'refund';
                    }
                    default:
                        return 'unknown';
                }
            })();
            const liquidity = (() => {
                if (type.toLowerCase() === 'refund' && ['withdraw', 'deposit'].includes(txType))
                    return { type: getLiquidityType(refundMemo.split(':')[1]) };
                if (txType === 'withdraw')
                    return { type: getLiquidityType(action.pools[0]) };
            })();
            const swap = txType === 'swap' ? { type: getSwapType(swapMemo || refundMemo) } : undefined;
            return { method, liquidity, swap };
        };
        this.axiosMidgard = axios_1.default.create({ baseURL: args.midgardUrl });
    }
    async parse(memo) {
        const [type] = memo.split(':');
        switch (type.toLowerCase()) {
            case 'swap':
            case '=':
            case 's': {
                return {
                    data: { parser: 'thorchain', method: 'swap', memo, swap: { type: getSwapType(memo) } },
                    trade: { dexName: types_1.Dex.Thor, type: types_1.TradeType.Swap, memo },
                };
            }
            case 'add':
            case '+': {
                const [, pool] = memo.split(':');
                const type = getLiquidityType(pool);
                return { data: { parser: 'thorchain', method: 'deposit', memo, liquidity: { type } } };
            }
            case 'withdraw':
            case '-':
            case 'wd': {
                const [, pool] = memo.split(':');
                const type = getLiquidityType(pool);
                return { data: { parser: 'thorchain', method: 'withdraw', memo, liquidity: { type } } };
            }
            case '$+':
            case 'loan+':
                return { data: { parser: 'thorchain', memo, method: 'loanOpen' } };
            case '$-':
            case 'loan-':
                return { data: { parser: 'thorchain', memo, method: 'loanRepayment' } };
            case 'out': {
                const extraMetadata = await this.getExtraMetadata(memo);
                if (!extraMetadata)
                    return;
                return { data: { parser: 'thorchain', memo, ...extraMetadata } };
            }
            case 'refund':
                const extraMetadata = await this.getExtraMetadata(memo);
                if (!extraMetadata)
                    return;
                return { data: { parser: 'thorchain', memo, ...extraMetadata } };
            default:
                return;
        }
    }
}
exports.Parser = Parser;
